import CommonCardHeader from "../../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { productListFilterHeaderData } from "../../../../Data/Application/Ecommerce/ProductList";

const ProductListFilterHeader = () => {

  return (
    <CommonCardHeader title="Individual column searching (text inputs)" span={productListFilterHeaderData} />
  );
};

export default ProductListFilterHeader;
